import { resetSubInvoice } from '../State/subInvoice'
import { resetEditing } from '../State/editing'

export default () => (dispatch) => {

  dispatch(resetSubInvoice())
  dispatch(resetEditing())

}
